// cleanSlate behaviour adapters — assembly point.
//
// cleanSlate extends the base tier directly, so it must supply its own
// implementations of the behaviour contract (base ships throwing stubs — see
// core/themes/base/scripts/behaviors.js + behaviors.contract.md). This is an
// incremental layer: only the behaviours the currently-built pages exercise are
// implemented; everything else inherits base's throwing stub and is filled in when
// its page is built.
//
// Each behaviour lives in its own file under ./behaviors/ (one per behaviour) and is
// assembled here over base's contract object. hm is injected by hiveMind.adopt
// (behaviors.hm = hm); it's defined below as an accessor that mirrors into the shared
// ./behaviors/context.js so the per-behaviour modules that need hm (passwordMeter)
// can read it without importing this assembled object (which would be a cycle).
//
// bridgeTierAttrs stays the base no-op: cleanSlate has no framework-level markup
// auto-discovery (no data-bs-*/data-kt-* mirroring), so e.g. the toast close button
// and the password controls are wired directly inside their adapters.

import baseBehaviors from '../../../../core/themes/base/scripts/behaviors.js';
import context from './behaviors/context.js';
import toast from './behaviors/toast.js';
import passwordMeter from './behaviors/passwordMeter.js';
import blockUI from './behaviors/blockUI.js';
import collapse from './behaviors/collapse.js';
import activation from './behaviors/activation.js';
import submenu from './behaviors/submenu.js';
import popover from './behaviors/popover.js';
import tags from './behaviors/tags.js';
import modal from './behaviors/modal.js';
import drawer from './behaviors/drawer.js';

const behaviors = Object.assign({}, baseBehaviors, {
    toast,
    passwordMeter,
    blockUI,
    collapse,
    activation,
    submenu,
    drawer,
    popover,
    tags,
    modal
});

// hm accessor: hiveMind.adopt() does `behaviors.hm = hm` (it only assigns when
// Object.hasOwn(behaviors, 'hm') — an accessor counts as an own property), and this
// routes the value into the shared context so per-behaviour modules read the same hm.
Object.defineProperty(behaviors, 'hm', {
    get: function () { return context.hm; },
    set: function (value) { context.hm = value; },
    enumerable: true,
    configurable: true
});

export default behaviors;
